export default __webpack_public_path__ + "static/media/Steel City-4.2056f908.jpg";